import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';

const RevealSection = ({ children, className = '', delay = 0 }) => {
  const ref = useScrollReveal();
  return (
    <div
      ref={ref}
      className={`reveal-section ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </div>
  );
};

export default RevealSection;
